import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

/** THE ANNUAL — each cohort's best capstones, published permanently. Public, like the Register. */
export default function Annual() {
  const [vols, setVols] = useState([]);

  useEffect(() => onSnapshot(collection(db, "annual"), (snap) =>
    setVols(snap.docs.map((d) => ({ id: d.id, ...d.data() })).sort((a, b) => b.id.localeCompare(a.id)))), []);

  return (
    <div style={{ background: "var(--paper)", minHeight: "100vh" }}>
      <header className="masthead">
        <div className="wrap" style={{ paddingTop: 22, paddingBottom: 22 }}>
          <div style={{ fontFamily: "Archivo, sans-serif", fontWeight: 700, letterSpacing: ".34em", fontSize: 22 }}>ATELIER</div>
          <div style={{ fontSize: 13, color: "#93a0ac" }}>The Annual — selected capstones, by cohort</div>
        </div>
      </header>
      <div className="wrap" style={{ paddingTop: 24, paddingBottom: 60, maxWidth: 860 }}>
        <p style={{ maxWidth: "66ch" }}>
          Each cohort's strongest client engagements, selected at Jury Day and published permanently —
          the degree-show tradition, in the open. Named prizes are awarded by the external Jury. Every
          entry that cites a credential is verifiable on the <a href="/register">Register</a>.
        </p>
        {vols.map((v) => (
          <div key={v.id} style={{ marginTop: 28 }}>
            <h2 style={{ fontSize: 20, borderBottom: "2px solid var(--ink)", paddingBottom: 6 }}>
              {v.id.replace("cohort-", "Class of Cohort ")}
            </h2>
            {(v.entries ?? []).map((e, i) => (
              <div key={i} className="card" style={{ marginTop: 12 }}>
                <div className="row between wrapflex">
                  <div>
                    <strong style={{ fontSize: 16 }}>{e.capstoneTitle}</strong>
                    <div style={{ fontSize: 14, color: "var(--graphite)" }}>{e.name}{e.award ? ` · ${e.award}` : ""}</div>
                    {e.caseStudyUrl && <a href={e.caseStudyUrl} target="_blank" rel="noreferrer" style={{ fontSize: 14 }}>Read the case study</a>}
                  </div>
                  <div style={{ textAlign: "right" }}>
                    {e.prize && (
                      <span className="stamp tier3" style={{ display: "inline-block" }}>{e.prize}</span>
                    )}
                    {e.credentialId && <div className="mono" style={{ fontSize: 11, color: "var(--graphite)", marginTop: 6 }}>{e.credentialId}</div>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ))}
        {!vols.length && <p style={{ color: "var(--graphite)", fontStyle: "italic", marginTop: 20 }}>The first volume is published at the first Jury Day.</p>}
      </div>
    </div>
  );
}
